import PageHeaderCounter from './PageHeaderCounter';

export default PageHeaderCounter;
